module.exports = __webpack_public_path__ + "img/Ma.Maritime.Breakwaters.Compositebreakwater-CAU.Massconcrete.7d096790.png";